module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch01_hd",
      "role": "doc-chapter"
    }
  }, [_c('h2', {
    staticClass: "h2chap",
    attrs: {
      "id": "ch01_hd"
    }
  }, [_vm._v("CHAPTER 1: HUNTED")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "f1"
  }, [_vm._v("va Nine")]), _vm._v(" could scarcely hear anything above her own ragged breathing. Her pale green eyes, wide and wild, searched for a clear path through the dense undergrowth of the Wandering Forest. Burning leg muscles carried her past fallen trees and over moss-laden stones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This way! Come on!” Eva shouted. Her instinct warned that her voice would give away her location, but she suspected it didn’t matter. "), _c('i', [_vm._v("The beast knows exactly where I am,")]), _vm._v(" she thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 4",
      "id": "page_4",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Lagging behind Eva was the teenage pilot Hailey Turner. Eva ran back, seized Hailey by the hand, and yanked him along with her. They moved quickly through the dappled shadow of the canopy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have to keep moving,” she whispered hoarsely. “Let’s go.” She pushed aside a cluster of feathery blooms on waist-high stalks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can you run so fast?” Hailey tried to catch his breath. “You’re—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A low snarl sliced through the stillness of the wood. Startled turnfins flapped away from the disruption. The beast was not far now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Over here!” Eva bolted toward a clearing where the trees thinned out. Here she and Hailey could make up more ground, but so too could the beast. She glanced over her shoulder and saw a blur of tawny fur with horns on its head. It bound through the thick underbrush as effortlessly as a spiderfish swimming through water, with its razor claws sending up leaves and bark in its wake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can’t you… ask this thing… to leave us alone?” Hailey asked between gasps. He would not be able to keep up this pace much longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve tried to, but it is not responding.” For a moment Eva wondered if her newfound ability to communicate with all forest denizens had somehow "), _c('span', {
    attrs: {
      "aria-label": "page 5",
      "id": "page_5",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("vanished. But perhaps this creature simply did not want to talk—it wanted to eat.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva and Hailey dashed across the glade and back into the shadowy cover of the forest. She looked once more at their pursuer, but it was nowhere to be seen. Before Eva could turn around, she tripped headlong over a large fallen log. As she brushed dead leaves from her colorless hair, Eva realized she had landed next to a giant sundew bush. The plant’s sticky stalks immediately bent and quivered in her direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Its voice entered her mind. "), _c('i', [_vm._v("Let me touch you. Let me hold you.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva scooted away from the sundew. Her abilities had not left her, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you okay?” Hailey climbed over the log.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shhh!” Eva grabbed the back of Hailey’s utili-T-shirt and yanked him down to the ground. Together they crouched behind the rotting log. Eva noticed that the ground dipped underneath the log to form a small hollow. She began clawing the forest debris out from the hollow. “Get under here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it will find—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just do it,” she hissed. Although she heard no sound, Eva knew the beast was nearby, stalking them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d09468c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781481403887/xhtml/ch01.vue
// module id = 81
// module chunks = 0